// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"bb4bf99f60db1974f7f0","453":"982a08db6d718ddc32b7"}[chunkId] + ".js";
};